import { httpClient } from '@/services/httpClient';

// Re-export httpClient as api for convenient importing
export const api = httpClient;
export { httpClient };

export default api;
